<template>
  <a-form :form="form">
    <a-row :gutter="16">
      <a-col :xs="{ span: 24 }" :lg="{ span: 12 }">
        <a-form-item label="Request Date">
          <a-config-provider :locale="getLocalConfigProvider()">
          <a-date-picker
            placeholder="Select Date"
            :format="getDefaultDateFormat"
            v-decorator="['request_dt', { rules: [{ required: true }] }]"
          />
          </a-config-provider>
        </a-form-item>
        <a-form-item label="NTPN">
          <a-input
            v-decorator="['ntpn', {
              rules: [{ required: true }],
              initialValue: null,
            }]"
          ></a-input>
        </a-form-item>
        <a-form-item label="Tax Type">
          <a-select v-decorator="['tax_type', { rules: [{ required: true }], initialValue: null }]">
            <a-select-option
                v-for="item in getType_tax"
                :key="item.value"
                :value="item.value"
            >
            {{ item.text }}
            </a-select-option>
          </a-select>
        </a-form-item>
        <a-form-item label="Month-Year">
         <a-month-picker
            placeholder="Select Month-Year"
            :format="'MM-YYYY'"
            picker="month"
            :allowClear="true"
            v-decorator="['month_year', { rules: [{ required: true }], initialValue: null }]"
          />
        </a-form-item>
      </a-col>
      <a-col :xs="{ span: 24 }" :lg="{ span: 12 }">
        <a-form-item label="KAP">
          <a-input
            v-decorator="['kap', {
              rules: [{ required: true }],
              initialValue: null,
            }]"
          ></a-input>
        </a-form-item>
        <a-form-item label="KJS">
          <a-input
            v-decorator="['kjs', {
              rules: [{ required: true }],
              initialValue: null,
            }]"
          ></a-input>
        </a-form-item>
        <a-form-item label="Value">
          <a-input-number
            class="m-width-full m-text-align-right"
            v-decorator="[
              'value',
              {
                rules: [{ required: true }],
                initialValue: null,
              },
            ]"
            @keydown="onlyNumber"
            :formatter="value => `${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ',')"
            :parser="(value) => value.replace(/\\s?|(,*)/g, '')"
          ></a-input-number>
        </a-form-item>
      </a-col>
    </a-row>
  </a-form>
</template>
<script>
import { mapGetters } from "vuex";
import GlobalMethod from "@/mixins/GlobalMethod.js";
import moment from "moment";

export default {
  name: "request_PBK",
  mixins: [GlobalMethod],
  data() {
    return {

    }
  },
  created() {
    this.form = this.$form.createForm(this);
  },
  mounted() {
    this.$store.dispatch("Fetch_TYPE_TAX");
  },
  computed: {
    ...mapGetters([
      "getScreen",
      "getAuth",
      "getStandartFormatDate",
      "getDateTimeFormat",
      "getDefaultDateFormat",
      "getType_tax",
    ]),
  },
  methods: {
    moment,
    handleRef() {
      this.form.validateFields((err, values) => {
        if (err) {
          this.displayMessage("form-warning");
          return;
        }

        Event.$emit("dataPBK", {
          values: {
            kap: values.kap,
            kjs: values.kjs,
            month_year: moment(values.month_year).format('YYYY-MM'),
            ntpn: values.ntpn,
            request_dt:  moment(values.request_dt).format(this.getStandartFormatDate),
            tax_type: values.tax_type,
            value: values.value
          }
        });
      })
    }
  }
}
</script>